import { JudgingQuestion } from './judging-question';
import { Award, copyAward } from './award';
import { AwardLead, copyAwardLead, compareAwardLead } from './award-lead';
import { AwardExecutiveSummaryFileTemplate, copyAwardExecutiveSummaryFileTemplate, compareAwardExecutiveSummaryFileTemplate } from './award-executive-summary-file-template';
import { clone, isEqual } from 'es-toolkit';

export interface AwardForStaff {
  award: Award;
  judgingQuestions: JudgingQuestion[];
  awardLeads: AwardLead[];
  awardExecutiveSummaryFileTemplate?: AwardExecutiveSummaryFileTemplate;
}

export function copyAwardForStaff(awardForStaff: AwardForStaff): AwardForStaff {
  const awardLeads: AwardLead[] = [];
  awardForStaff.awardLeads.forEach(awardlead => awardLeads.push(copyAwardLead(awardlead)));

  const judgingQuestions: JudgingQuestion[] = [];
  awardForStaff.judgingQuestions.forEach(judgingQuestion => judgingQuestions.push(clone(judgingQuestion)));

  return {
    award: copyAward(awardForStaff.award),
    awardLeads,
    judgingQuestions,
    awardExecutiveSummaryFileTemplate: awardForStaff.awardExecutiveSummaryFileTemplate ?
      copyAwardExecutiveSummaryFileTemplate(awardForStaff.awardExecutiveSummaryFileTemplate) : undefined
  };
}

export function compareAwardForStaff(awardForStaffA: AwardForStaff, awardForStaffB: AwardForStaff): boolean {
  if (!isEqual(awardForStaffA.award, awardForStaffB.award)) return false;

  if (!compareAwardExecutiveSummaryFileTemplate(
    awardForStaffA.awardExecutiveSummaryFileTemplate!,
    awardForStaffB.awardExecutiveSummaryFileTemplate!
  )) return false;

  if (awardForStaffA.awardLeads.length !== awardForStaffB.awardLeads.length) return false;
  for (let index = 0; index < awardForStaffA.awardLeads.length; index++) {
    const awardLeadA = awardForStaffA.awardLeads[index];
    const awardLeadB = awardForStaffB.awardLeads.find(awardLead => awardLead.emailAddress === awardLeadA.emailAddress);
    if (!awardLeadB) return false;
    if (!compareAwardLead(awardLeadA, awardLeadB)) return false;
  }

  if (awardForStaffA.judgingQuestions.length !== awardForStaffB.judgingQuestions.length) return false;
  for (let index = 0; index < awardForStaffA.judgingQuestions.length; index++) {
    const judgingQuestionA = awardForStaffA.judgingQuestions[index];
    const judgingQuestionB = awardForStaffB.judgingQuestions.find(judgingQuestion => judgingQuestion.questionId === judgingQuestionA.questionId);
    if (!judgingQuestionB) return false;
    if (!isEqual(judgingQuestionA, judgingQuestionB)) return false;
  }

  return true;
}
